import _ from 'lodash'

import {
  UNIVERSAL_EXPORT_TIMEFRAME_MONTH
} from 'common/constants'

import { MOBILE_BREAKPOINT } from 'broker/util/constants'

import { formatMoney, formatNumber, toFixed } from 'accounting-js'

export const getTimeframeFromFilterList = filters => {
  const timeframeFilter = filters.filter(filter => filter.filter_type === 'timeframe')
  if (timeframeFilter.length && timeframeFilter[0].filter_value) {
    return timeframeFilter[0].filter_value
  }
  return UNIVERSAL_EXPORT_TIMEFRAME_MONTH
}

export const getQueriesFromFilterList = filters => {
  return filters.filter(filter => filter.filter_type !== 'timeframe')
}

export const filtersWithValues = filters => {
  return filters.filter(filter => filter.filter_value !== null)
}

export const exportPostData = ({activeFilters, searchTerm, excludeOnHold, excludeDuplicates, emailAddress, exportUrl}) => {
  const postData = {
    timeframe: getTimeframeFromFilterList(activeFilters),
    exclude_on_hold: excludeOnHold,
    exclude_duplicates: excludeDuplicates,
    email_address: emailAddress,
    export_url: exportUrl
  }
  if (searchTerm && searchTerm !== '') {
    postData.query = searchTerm
  }
  getQueriesFromFilterList(activeFilters).forEach((filter) => {
    postData[filter.filter_type] = filter.filter_value
  })

  return postData
}

export const handleExport = ({exportUrl, activeFilters, searchTerm, excludeOnHold, excludeDuplicates, onload}) => {
  let queryParams = '?timeframe=' + getTimeframeFromFilterList(activeFilters)
  if (searchTerm && searchTerm !== '') {
    queryParams += '&query=' + encodeURIComponent(this.state.searchTerm)
  }

  getQueriesFromFilterList(activeFilters).forEach((filter) => {
    queryParams += '&' + filter.filter_type + "=" + encodeURIComponent(filter.filter_value)
  })

  if (typeof excludeOnHold != 'undefined') {
    queryParams += '&exclude_on_hold=' + excludeOnHold
  }

  if (typeof excludeDuplicates != 'undefined') {
    queryParams += '&exclude_duplicates=' + excludeDuplicates
  }
  const result = window.open(exportUrl + queryParams)
  if (onload && result) {
    result.onload = onload
  }
}

export const renameFilterItemForSegment = (filterItem) => {
  return 'search_filter_' + filterItem.value.toLowerCase().replace(' ', '_')
}

export const exportSearchFiltersForSegment = (filterTypeOptionsArray, activeFiltersArray, sensitiveFilterOverrides=null) => {
  const exportedFilters = {}

  filterTypeOptionsArray.forEach((filterTypeOption) => {
    const properLabel = renameFilterItemForSegment(filterTypeOption)
    const filterObject = activeFiltersArray.find(filterEntry => filterEntry.filter_type === filterTypeOption.value)
    const sensitiveOverride = sensitiveFilterOverrides && sensitiveFilterOverrides[filterTypeOption.value]

    const filterValue = () => {
      if (!filterObject) {
        return 'none'
      } else if (sensitiveOverride) {
        return sensitiveOverride
      } else {
        return filterObject.filter_value
      }
    }

    exportedFilters[properLabel] = filterValue()

  })

  return exportedFilters
}

export const wholeDollars = amount => formatMoney(amount, { symbol: "$", precision: 0, thousand: "," })
export const wholeInteger = amount => formatNumber(amount, { precision: 0, thousand: ","})

export const wholePercent = amount => {
  const toFormat = amount * 100.0
  return `${toFixed(toFormat, 0)}%`
}

export const percentToHundredths = amount => {
  const toFormat = amount * 100.0
  return `${toFixed(toFormat, 2)}%`
}

export function valueOrNull(value) {
  return _.isNil(value) ? null : value
}

export function prettyTime(duration = 0) {
  const minutes = Math.floor(duration / 60)
  const seconds = duration % 60
  if (minutes) {
    return `${wholeInteger(minutes)}m ${wholeInteger(seconds)}s`
  }

  return `${wholeInteger(seconds)}s`
}

export function formatOrPlaceholder(placeholder, value, formatFn, options = {}) {
  if (_.isNull(value)) {
    const { prefix, suffix } = options
    return `${prefix || ''}${placeholder}${suffix || ''}`
  }

  return formatFn(value)
}

export function formatOrDash(value, formatFn, options) {
  return formatOrPlaceholder('-', value, formatFn, options)
}

export function isMobile() {
  if (!(window && window.matchMedia)) {
    return false
  }
  return window.matchMedia(MOBILE_BREAKPOINT).matches
}

export function isActiveTab(tabValue) {
  return tabValue === location.pathname
}

export function isRootActiveTab(tabValue) {
  const pathComponents = _.filter(location.pathname.split('/'), x => !!x)
  const rootPath = _.first(pathComponents)

  return tabValue === `/${rootPath}`
}
